import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const bannerSpacing = css`
    margin-bottom: ${Spacing.MD}px;
`;
